import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectors as comexSelectors, actions as comexActions
} from "reducers/comex";
import { connect } from "react-redux";
import Notification from "pages/_components/Notification";
import Button from "pages/_components/Button";
import TransactionList from "pages/_components/product/List";
import GridTable from "pages/_components/GridTable/GridTable";
import TransactionItem from "pages/comex/_components/ItemRow";
import DraftTransactionItem from "pages/comex/_components/DraftItemRow";
import TitleColumns from "pages/comex/_components/TitleColumns";
import DraftTitleColumns from "pages/comex/_components/DraftTitleColumns";
import CustomData from "pages/_components/CustomData/CustomData";
import * as i18n from "util/i18n";
import { push } from "connected-react-router";
import { Formik } from "formik";
import { Col, Row } from "react-bootstrap";
import { COMEX_STATE } from "pages/comex/constants"
import Drawer from "pages/_components/Drawer/Drawer";

const TransactionsHistory = ({ transactionsList, draftTransactionsList, finishedTransactionsList, isDesktop, type }) => {
    const dispatch = useDispatch();
    const fetching = useSelector(comexSelectors.getFetching);

    const transactionsPerBatch = isDesktop ? 10 : 5;
    const [transactionsToDisplay, setTransactionsToDisplay] = useState([]);
    const [fetchingMoreData, setFetchingMoreData] = useState(false);
    const hasMoreData = transactionsList?.length > transactionsToDisplay?.length;
    const draftHasMoreData = draftTransactionsList?.length > transactionsToDisplay?.length;
    const finishedHasMoreData = finishedTransactionsList?.length > transactionsToDisplay?.length;
    const row = isDesktop ? 1 : 4;
   
    const moreData = (type == COMEX_STATE.SENT && hasMoreData) ||  (type == COMEX_STATE.DRAFT && draftHasMoreData) ||  (type == COMEX_STATE.FINISHED && finishedHasMoreData)
    const [form, setForm] = useState(null);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const [actionDrawer, setActionDrawer] = useState({ showDrawer: false, contentDrawer: null });
     const [showDrawer, setShowDrawer] = useState(false);

    const handleCloseActionDrawer = () => {
        setActionDrawer({ showDrawer: false, contentDrawer: null, title: "" });
    };

    useEffect(() => {
        if (type == COMEX_STATE.SENT && transactionsList?.length > 0) {
            setTransactionsToDisplay(transactionsList?.slice(0, transactionsPerBatch));
        }
        if (type == COMEX_STATE.DRAFT && draftTransactionsList?.length > 0) {
            setTransactionsToDisplay(draftTransactionsList?.slice(0, transactionsPerBatch));
        }
        if (type == COMEX_STATE.FINISHED && finishedTransactionsList?.length > 0) {
            setTransactionsToDisplay(finishedTransactionsList?.slice(0, transactionsPerBatch));
        }
    }, [type]);

    useEffect(() => {
        if (type == COMEX_STATE.SENT)
            setFetchingMoreData(fetching && (transactionsList && transactionsList.length === 0 || hasMoreData));

        if (type == COMEX_STATE.DRAFT)
            setFetchingMoreData(fetching && (draftTransactionsList && draftTransactionsList.length === 0 || draftHasMoreData));

        if (type == COMEX_STATE.FINISHED)
            setFetchingMoreData(fetching && (finishedTransactionsList && finishedTransactionsList.length === 0 || finishedHasMoreData));

    }, [fetching]);


    const fetchMoreTransactions = () => {
        const currentLength = transactionsToDisplay?.length;
        const nextLength = currentLength + transactionsPerBatch;
        let newItems = null;
        if (type == COMEX_STATE.SENT)
            newItems = transactionsList?.slice(0, nextLength);
        if (type == COMEX_STATE.DRAFT)
            newItems = draftTransactionsList?.slice(0, nextLength);
        if (type == COMEX_STATE.FINISHED)
            newItems = finishedTransactionsList?.slice(0, nextLength);
      
        setTransactionsToDisplay(newItems);
    };

    const viewTicket = (transactionId) => {
       dispatch(push(`comex/transaction/${transactionId}`));
    };


    const resumeTransaction = () => {
       let comexData = null;
       let selectedId = null;
       if (form)  {
            selectedId = Object.entries(form).filter(([id, value]) => value == true ).map(([id]) => id);
            transactionsToDisplay.forEach((item) => {
                if (item.idComexRequest == selectedId[0]) {
                    comexData = item.comexData;
                }
            })
        }
        else
            return;


       const comexTransfer = JSON.parse(comexData)
       const currentStep = comexTransfer.step;
       const isContinue = comexTransfer.isContinue;
       const concept = comexTransfer.concept;
       const goodsDocumentation = comexTransfer.goodsDocumentation;
       const comexDocumentation = comexTransfer.comexDocumentation;

       const isService = concept.includes("S");
       const isGoods = concept.includes("B");

       // Reseteo DDJJs
       comexTransfer.ddjj = {};
       comexTransfer.ddjjGoods = {};
       comexTransfer.ddjjServices = {};

       // Adecuar campos de fecha
     
       if (comexTransfer.tax?.constitutionDate)
           comexTransfer.tax.constitutionDate = new Date(comexTransfer.tax.constitutionDate);

       if (isGoods) {
           if (comexTransfer.dispatchData) {
                comexTransfer.dispatchData.customsEntryDate = new Date(comexTransfer.dispatchData.customsEntryDate);
                comexTransfer.dispatchData.expirationDate = new Date(comexTransfer.dispatchData.expirationDate);
                if (comexTransfer.dispatchData.deliveryEstimatedTime!=null && comexTransfer.dispatchData.deliveryEstimatedTime!="")
                    comexTransfer.dispatchData.deliveryEstimatedTime = new Date(comexTransfer.dispatchData.deliveryEstimatedTime);
             }
       }

       // Actualizo estado
       dispatch(comexActions.setComexDataForContinue(comexTransfer, selectedId[0], goodsDocumentation, comexDocumentation));

       // paso - urlActual - proximaUrl
       const urlsByStep= [
            ["stepORIGINACCOUNT","/comex/transfer"],
            ["stepCLEARANCE","/comex/clearance"],
            ["stepDISPATCH","/comex/goods/paymentdata"],
            ["stepTAXRETENTION","/comex/retention"],
            ["stepGOODSDOCUMENT","/comex/goods/documentation"],
            ["stepGOODSDDJJ","/comex/goods/documentation"], // No tiene boton guardar entonces reanudo al paso anterior -- Este paso no debe reestablecer su estado
            // Si es bienes, retornar a esta url. Si es servicios, debe retornar a /comex/service/payment
            // Si no es bienes y no es servicios, debe retornar a /comex/documentation
            ["stepDDJJ","/comex/goods/documentation"], // No tiene boton guardar entonces reanudo al paso anterior -- Este paso no debe reestablecer su estado
            ["stepADITIONALDOCUMENT","/comex/documentation"],
            ["stepSERVICEDOCUMENT","/comex/service/documentation"],
            ["stepSERVICEPAYMENT","/comex/service/payment"],
            ["stepSERVICEDDJJ","/comex/service/payment"],
       ]

       // Redirecciono a paso guardado
       for (let [step,  url] of urlsByStep)
            if (currentStep == step) {
                if (step == "stepDDJJ" && isService) 
                    url = "/comex/service/payment";
                if (step == "stepDDJJ" && (!isService && !isGoods)) 
                    url = "/comex/documentation";
                dispatch(push(url));
            }

    };

    useEffect(() => {
        const params = {
            queryType: type,
        };

        if (type == COMEX_STATE.DRAFT && draftTransactionsList && draftTransactionsList.length==0)
            dispatch(comexActions.getDraftTransactionsListRequest(params));

        if (type == COMEX_STATE.SENT && transactionsList && transactionsList.length==0)
            dispatch(comexActions.getTransactionsListRequest(params));

        if (type == COMEX_STATE.FINISHED && finishedTransactionsList && finishedTransactionsList.length==0)
            dispatch(comexActions.getFinishedTransactionsListRequest(params));

    }, [type]);

  const getColumnTemplate = (isDesktop) => {
      if (isDesktop) 
          return "repeat(5, 1fr) 40px";
      else
          return "repeat(1, 1fr) 40px";
  };  

   const handleCheckboxChange = (setFieldValue, idComexRequest) => {
        setSelectedRecord(idComexRequest);
        setFieldValue(idComexRequest, true);
        transactionsToDisplay.forEach((item) => {
            if (item.idComexRequest !== idComexRequest) {
                setFieldValue(item.idComexRequest, false);
            }
        });
    };  
 
  return (
    <Fragment>
      <Notification scopeToShow="comexTransactions" />
                  <b>&nbsp;</b>
                    {transactionsToDisplay && transactionsToDisplay?.length > 0 ? (
                         <Formik>
                        {({ values, setFieldValue }) => {
                            setForm(values);
                            return (
                            <>
                        <TransactionList
                            fetchingWithPreviousData
                            fetching={fetching && fetchingMoreData}
                            items={transactionsToDisplay}
                            noFiltersDataText="global.no.results"
                            renderItem={(item) => (
                                <GridTable.Container
                                    key={`payments-item-${item.idTransaction}`}
                                    columns={!isDesktop && 5}
                                    columnsTemplate={getColumnTemplate(isDesktop)}
                                    className={!isDesktop && "box box-shadow"}>
                                        {type == COMEX_STATE.SENT || type == COMEX_STATE.FINISHED ? (
                                             <TransactionItem
                                                key={`transaction-${item.idTransaction}`}
                                                transaction={item}
                                                isDesktop={isDesktop}
                                                viewTicket={()=>viewTicket(item.idTransaction)}
                                                type={type}
                                                setActionDrawer={setActionDrawer}
                                            />
                                        ) : (
                                            <DraftTransactionItem
                                                key={`transaction-${item.idComexRequest}`}
                                                transaction={item}
                                                isDesktop={isDesktop}
                                                onChange={() => handleCheckboxChange(setFieldValue, item.idComexRequest)}
                                            />
                                        )}
                                      
                                </GridTable.Container>
                            )}>
                            {(listItem) => (
                                <GridTable>
                                    {isDesktop && (
                                        <GridTable.Header>
                                              {type == COMEX_STATE.SENT || type == COMEX_STATE.FINISHED ? (
                                                    <GridTable.Container rows={row} columnsTemplate="repeat(5, 1fr) 40px">
                                                        <TitleColumns />{" "}
                                                    </GridTable.Container>
                                                ) : (
                                                   <GridTable.Container rows={row} columnsTemplate="repeat(5, 1fr) 40px">
                                                        <DraftTitleColumns />{" "}
                                                    </GridTable.Container>
                                                )}
                                        </GridTable.Header>
                                    )}
                                    <GridTable.Body>{listItem}</GridTable.Body>
                                    {moreData && (
                                        <Button
                                            bsStyle="link"
                                            onClick={() => fetchMoreTransactions()}
                                            image="images/figma/icon/arrow.svg"
                                            label="global.showMore"
                                            className="view-more"
                                        />
                                    )}
                                </GridTable>
                            )}
                        </TransactionList>
                            {type == COMEX_STATE.DRAFT && (
                                <Row className="form-actions">
                                    <Col xs={12} md={4} mdOffset={4}>
                                        <Button
                                            bsStyle="primary"
                                            label="global.continue"
                                            loading={false}
                                            block
                                            onClick={() => resumeTransaction()}
                                            disabled={selectedRecord == null}
                                        />
                                    </Col>
                                </Row>
                             )}
                        </> );
                         }}
                         </Formik>
                    ) : (
                        <div className="container--alert" role="alert">
                            <div className="alert alert-info">
                                <CustomData
                                    icon="information_fill.svg"
                                    titleText={i18n.get(`comexTransactions.${type}.noresults`)}
                                    keepSpaceIfNoValue={false}
                                />
                            </div>
                        </div>
                    )}
                    <Drawer  openSidebar={actionDrawer.showDrawer} onClose={handleCloseActionDrawer}>
                        {actionDrawer.contentDrawer}
                    </Drawer>
                    
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
    fetching: comexSelectors.getFetching(state),
    transactionsList: comexSelectors.getTransactionsList(state),
    draftTransactionsList: comexSelectors.getDraftTransactionsList(state),
    finishedTransactionsList: comexSelectors.getFinishedTransactionsList(state),
});

export default connect(mapStateToProps)(TransactionsHistory);
